import React from 'react';
import { Icon } from './Icon';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: 'terms' | 'privacy';
}
export function LegalModal({
  isOpen,
  onClose,
  type
}: LegalModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] overflow-y-auto" data-id="element-212">
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} data-id="element-213" />

      {/* Modal */}
      <div className="relative min-h-screen flex items-start justify-center p-4 pt-20 pb-20" data-id="element-214">
        <div className="relative bg-white rounded-xl shadow-2xl max-w-3xl w-full max-h-[80vh] overflow-hidden" data-id="element-215">
          {/* Header */}
          <div className="sticky top-0 bg-white border-b border-gray-100 px-8 py-5 flex items-center justify-between z-10" data-id="element-216">
            <h2 className="font-serif text-2xl text-gray-900" data-id="element-217">
              {type === 'terms' ? 'Términos de Servicio' : 'Política de Privacidad'}
            </h2>
            <button onClick={onClose} className="w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors" data-id="element-218">
              <Icon name="x" size={20} className="text-gray-600" data-id="element-219" />
            </button>
          </div>

          {/* Content */}
          <div className="px-8 py-6 overflow-y-auto max-h-[calc(80vh-80px)]" data-id="element-220">
            {type === 'terms' ? <TermsContent data-id="element-221" /> : <PrivacyContent data-id="element-222" />}
          </div>
        </div>
      </div>
    </div>;
}
function TermsContent() {
  return <div className="prose prose-gray max-w-none" data-id="element-223">
      <p className="text-sm text-gray-500 mb-6" data-id="element-224">
        Última actualización: Febrero 2025
      </p>

      <section className="mb-8" data-id="element-225">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-226">
          1. Aceptación de los Términos
        </h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-227">
          Al acceder y utilizar este sitio web operado por Alexaaa Narvaez (en
          adelante, "el Sitio"), usted acepta cumplir y estar sujeto a estos
          Términos de Servicio. Si no está de acuerdo con alguna parte de estos
          términos, no debe utilizar este Sitio.
        </p>
      </section>

      <section className="mb-8" data-id="element-228">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-229">
          2. Descripción del Servicio
        </h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-230">
          Este Sitio es una plataforma de presentación personal que ofrece
          información sobre Alexaaa Narvaez, incluyendo contenido multimedia,
          enlaces a redes sociales y acceso a plataformas de contenido de
          terceros. El Sitio actúa como un portal informativo y promocional.
        </p>
      </section>

      <section className="mb-8" data-id="element-231">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-232">
          3. Requisitos de Edad
        </h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-233">
          Este Sitio está destinado exclusivamente a personas mayores de 18
          años. Al utilizar este Sitio, usted declara y garantiza que tiene al
          menos 18 años de edad. Si es menor de 18 años, no está autorizado a
          utilizar este Sitio.
        </p>
      </section>

      <section className="mb-8" data-id="element-234">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-235">
          4. Propiedad Intelectual
        </h3>
        <p className="text-gray-600 leading-relaxed mb-3" data-id="element-236">
          Todo el contenido presente en este Sitio, incluyendo pero no limitado
          a:
        </p>
        <ul className="list-disc pl-6 text-gray-600 space-y-2" data-id="element-237">
          <li data-id="element-238">Fotografías e imágenes</li>
          <li data-id="element-239">Videos y contenido multimedia</li>
          <li data-id="element-240">Textos y descripciones</li>
          <li data-id="element-241">Diseño y elementos gráficos</li>
          <li data-id="element-242">Logotipos y marcas</li>
        </ul>
        <p className="text-gray-600 leading-relaxed mt-3" data-id="element-243">
          Son propiedad exclusiva de Alexaaa Narvaez o se utilizan con la debida
          autorización. Queda prohibida la reproducción, distribución,
          modificación o uso comercial de cualquier contenido sin autorización
          expresa por escrito.
        </p>
      </section>

      <section className="mb-8" data-id="element-244">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-245">
          5. Enlaces a Terceros
        </h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-246">
          Este Sitio puede contener enlaces a sitios web de terceros, incluyendo
          plataformas de contenido y redes sociales. Estos enlaces se
          proporcionan únicamente para su conveniencia. No tenemos control sobre
          el contenido de estos sitios y no asumimos responsabilidad por sus
          prácticas de privacidad o contenido. El acceso a estos sitios externos
          está sujeto a sus propios términos y condiciones.
        </p>
      </section>

      <section className="mb-8" data-id="element-247">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-248">
          6. Conducta del Usuario
        </h3>
        <p className="text-gray-600 leading-relaxed mb-3" data-id="element-249">
          Al utilizar este Sitio, usted se compromete a:
        </p>
        <ul className="list-disc pl-6 text-gray-600 space-y-2" data-id="element-250">
          <li data-id="element-251">No utilizar el Sitio para fines ilegales o no autorizados</li>
          <li data-id="element-252">No intentar acceder a áreas restringidas del Sitio</li>
          <li data-id="element-253">No copiar, distribuir o modificar contenido sin autorización</li>
          <li data-id="element-254">
            No realizar actividades que puedan dañar o sobrecargar el Sitio
          </li>
          <li data-id="element-255">No suplantar la identidad de otra persona o entidad</li>
        </ul>
      </section>

      <section className="mb-8" data-id="element-256">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-257">
          7. Limitación de Responsabilidad
        </h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-258">
          El Sitio se proporciona "tal cual" y "según disponibilidad". No
          garantizamos que el Sitio esté libre de errores o interrupciones. En
          ningún caso seremos responsables por daños directos, indirectos,
          incidentales, especiales o consecuentes que resulten del uso o la
          imposibilidad de uso del Sitio.
        </p>
      </section>

      <section className="mb-8" data-id="element-259">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-260">
          8. Modificaciones
        </h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-261">
          Nos reservamos el derecho de modificar estos Términos de Servicio en
          cualquier momento. Las modificaciones entrarán en vigor inmediatamente
          después de su publicación en el Sitio. Su uso continuado del Sitio
          después de cualquier modificación constituye su aceptación de los
          nuevos términos.
        </p>
      </section>

      <section className="mb-8" data-id="element-262">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-263">
          9. Ley Aplicable
        </h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-264">
          Estos Términos de Servicio se regirán e interpretarán de acuerdo con
          las leyes aplicables, sin tener en cuenta sus disposiciones sobre
          conflictos de leyes.
        </p>
      </section>

      <section className="mb-8" data-id="element-265">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-266">
          10. Contacto
        </h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-267">
          Para cualquier pregunta sobre estos Términos de Servicio, puede
          contactarnos a través de nuestras redes sociales oficiales o los
          canales de comunicación disponibles en el Sitio.
        </p>
      </section>

      <div className="mt-10 pt-6 border-t border-gray-200" data-id="element-268">
        <p className="text-sm text-gray-500 text-center" data-id="element-269">
          © 2025 Alexaaa Narvaez. Todos los derechos reservados.
        </p>
      </div>
    </div>;
}
function PrivacyContent() {
  return <div className="prose prose-gray max-w-none" data-id="element-270">
      <p className="text-sm text-gray-500 mb-6" data-id="element-271">
        Última actualización: Febrero 2025
      </p>

      <section className="mb-8" data-id="element-272">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-273">
          1. Introducción
        </h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-274">
          Alexaaa Narvaez (en adelante, "nosotros" o "nuestro") se compromete a
          proteger su privacidad. Esta Política de Privacidad explica cómo
          recopilamos, usamos y protegemos su información cuando visita nuestro
          sitio web.
        </p>
      </section>

      <section className="mb-8" data-id="element-275">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-276">
          2. Información que Recopilamos
        </h3>
        <p className="text-gray-600 leading-relaxed mb-3" data-id="element-277">
          Podemos recopilar los siguientes tipos de información:
        </p>
        <h4 className="font-medium text-gray-800 mt-4 mb-2" data-id="element-278">
          2.1 Información Automática
        </h4>
        <ul className="list-disc pl-6 text-gray-600 space-y-2" data-id="element-279">
          <li data-id="element-280">Dirección IP</li>
          <li data-id="element-281">Tipo de navegador y dispositivo</li>
          <li data-id="element-282">Páginas visitadas y tiempo de permanencia</li>
          <li data-id="element-283">Sitio web de referencia</li>
          <li data-id="element-284">Sistema operativo</li>
        </ul>
        <h4 className="font-medium text-gray-800 mt-4 mb-2" data-id="element-285">
          2.2 Cookies y Tecnologías Similares
        </h4>
        <p className="text-gray-600 leading-relaxed" data-id="element-286">
          Utilizamos cookies y tecnologías similares para mejorar su
          experiencia, analizar el tráfico del sitio y personalizar el
          contenido. Puede configurar su navegador para rechazar cookies, aunque
          esto puede afectar la funcionalidad del sitio.
        </p>
      </section>

      <section className="mb-8" data-id="element-287">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-288">
          3. Uso de la Información
        </h3>
        <p className="text-gray-600 leading-relaxed mb-3" data-id="element-289">
          Utilizamos la información recopilada para:
        </p>
        <ul className="list-disc pl-6 text-gray-600 space-y-2" data-id="element-290">
          <li data-id="element-291">Operar y mantener el sitio web</li>
          <li data-id="element-292">Mejorar la experiencia del usuario</li>
          <li data-id="element-293">Analizar el uso del sitio y las tendencias</li>
          <li data-id="element-294">Proteger contra actividades fraudulentas o ilegales</li>
          <li data-id="element-295">Cumplir con obligaciones legales</li>
        </ul>
      </section>

      <section className="mb-8" data-id="element-296">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-297">
          4. Servicios de Terceros
        </h3>
        <p className="text-gray-600 leading-relaxed mb-3" data-id="element-298">
          Nuestro sitio puede utilizar servicios de terceros que recopilan
          información, incluyendo:
        </p>
        <ul className="list-disc pl-6 text-gray-600 space-y-2" data-id="element-299">
          <li data-id="element-300">
            <strong data-id="element-301">Google Analytics:</strong> Para análisis de tráfico web
          </li>
          <li data-id="element-302">
            <strong data-id="element-303">Redes Sociales:</strong> Botones de compartir y enlaces a
            perfiles
          </li>
          <li data-id="element-304">
            <strong data-id="element-305">Plataformas de Contenido:</strong> Enlaces a servicios
            externos
          </li>
        </ul>
        <p className="text-gray-600 leading-relaxed mt-3" data-id="element-306">
          Estos servicios tienen sus propias políticas de privacidad que le
          recomendamos revisar.
        </p>
      </section>

      <section className="mb-8" data-id="element-307">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-308">
          5. Compartir Información
        </h3>
        <p className="text-gray-600 leading-relaxed mb-3" data-id="element-309">
          No vendemos ni alquilamos su información personal. Podemos compartir
          información en las siguientes circunstancias:
        </p>
        <ul className="list-disc pl-6 text-gray-600 space-y-2" data-id="element-310">
          <li data-id="element-311">Con proveedores de servicios que nos ayudan a operar el sitio</li>
          <li data-id="element-312">Cuando sea requerido por ley o proceso legal</li>
          <li data-id="element-313">
            Para proteger nuestros derechos, privacidad, seguridad o propiedad
          </li>
          <li data-id="element-314">En conexión con una fusión, adquisición o venta de activos</li>
        </ul>
      </section>

      <section className="mb-8" data-id="element-315">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-316">
          6. Seguridad de los Datos
        </h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-317">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger su información contra acceso no autorizado, alteración,
          divulgación o destrucción. Sin embargo, ningún método de transmisión
          por Internet es 100% seguro.
        </p>
      </section>

      <section className="mb-8" data-id="element-318">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-319">
          7. Sus Derechos
        </h3>
        <p className="text-gray-600 leading-relaxed mb-3" data-id="element-320">
          Dependiendo de su ubicación, puede tener los siguientes derechos:
        </p>
        <ul className="list-disc pl-6 text-gray-600 space-y-2" data-id="element-321">
          <li data-id="element-322">Acceder a la información que tenemos sobre usted</li>
          <li data-id="element-323">Solicitar la corrección de información inexacta</li>
          <li data-id="element-324">Solicitar la eliminación de su información</li>
          <li data-id="element-325">Oponerse al procesamiento de su información</li>
          <li data-id="element-326">Solicitar la portabilidad de sus datos</li>
        </ul>
      </section>

      <section className="mb-8" data-id="element-327">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-328">
          8. Retención de Datos
        </h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-329">
          Conservamos la información recopilada durante el tiempo necesario para
          cumplir con los fines descritos en esta política, a menos que la ley
          requiera o permita un período de retención más largo.
        </p>
      </section>

      <section className="mb-8" data-id="element-330">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-331">
          9. Menores de Edad
        </h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-332">
          Este sitio no está dirigido a menores de 18 años. No recopilamos
          intencionalmente información de menores. Si descubrimos que hemos
          recopilado información de un menor, tomaremos medidas para eliminarla.
        </p>
      </section>

      <section className="mb-8" data-id="element-333">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-334">
          10. Cambios a esta Política
        </h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-335">
          Podemos actualizar esta Política de Privacidad periódicamente. Le
          notificaremos cualquier cambio publicando la nueva política en esta
          página con una fecha de actualización revisada.
        </p>
      </section>

      <section className="mb-8" data-id="element-336">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-337">
          11. Contacto
        </h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-338">
          Si tiene preguntas sobre esta Política de Privacidad o desea ejercer
          sus derechos, puede contactarnos a través de nuestras redes sociales
          oficiales o los canales de comunicación disponibles en el sitio.
        </p>
      </section>

      <div className="mt-10 pt-6 border-t border-gray-200" data-id="element-339">
        <p className="text-sm text-gray-500 text-center" data-id="element-340">
          © 2025 Alexaaa Narvaez. Todos los derechos reservados.
        </p>
      </div>
    </div>;
}